import { FileUploader } from '../../../components/ui/FileUploader/FileUploader';
import {
  PHOTO_SLOT_LABELS,
  RECEIPT_PHOTO_SLOTS,
  type ReceiptPhotoSlot,
  type SlotFiles,
} from '../photoSlots';

interface PhotoSlotsInputProps {
  value: SlotFiles;
  onChange: (next: SlotFiles) => void;
  disabled?: boolean;
}

/**
 * One uploader per named photo slot (customer ID, address proof, car front,
 * car rear, car reg, chassis, logbook). The slot name becomes the stored
 * caption, matching what the Dispatch app writes.
 */
export function PhotoSlotsInput({ value, onChange, disabled }: PhotoSlotsInputProps): JSX.Element {
  function setSlot(slot: ReceiptPhotoSlot, files: File[]) {
    const next: SlotFiles = { ...value };
    const file = files[0];
    if (file === undefined) delete next[slot];
    else next[slot] = file;
    onChange(next);
  }

  return (
    <div
      data-testid="photo-slots"
      style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 16 }}
    >
      {RECEIPT_PHOTO_SLOTS.map((slot) => {
        const file = value[slot];
        return (
          <div key={slot} data-testid={`photo-slot-${slot}`}>
            <FileUploader
              label={PHOTO_SLOT_LABELS[slot] ?? slot}
              value={file === undefined ? [] : [file]}
              onChange={(files) => setSlot(slot, files)}
              maxFiles={1}
              disabled={disabled}
            />
          </div>
        );
      })}
    </div>
  );
}
